import { useState, useEffect } from "react";
import { useApp } from "context";
import { Custom } from "components";
import { IAppointment } from "interfaces";

type Props = {
  opened: boolean;
  onClose: () => void;
  appointment: IAppointment | null;
};

export const Health360PDF = (props: Props) => {
  const { t, theme, service, locale } = useApp();

  const [pdfDataURI, setPdfDataURI] = useState("");

  useEffect(() => {
    if (props.opened && props.appointment) {
      service.health360
        .download(props.appointment.appointmentId)
        .then((res) => {
          const [status, pdfBuffer] = res;
          const base64String = btoa(
            new Uint8Array(pdfBuffer.data).reduce(
              (acc, byte) => acc + String.fromCharCode(byte),
              ""
            )
          );
          setPdfDataURI(`data:application/pdf;base64,${base64String}`);
        });
    } else {
      setPdfDataURI("");
    }
  }, [props.opened]);

  return (
    <Custom.Modal
      header={"Health 360 Summary"}
      opened={props.opened}
      onClose={props.onClose}
    >
      <iframe
        title="PDF Viewer"
        width="100%"
        height="596px"
        src={pdfDataURI}
      ></iframe>
    </Custom.Modal>
  );
};
